export const CLAIM_STATUS_RECEIVED = 'received';
export const CLAIM_STATUS_IN_PROCESS = 'inProcess';
export const CLAIM_STATUS_ACCEPTED = 'accepted';
export const CLAIM_STATUS_REJECTED = 'rejected';
export const CLAIM_STATUS_STORNO = 'storno';
export const CLAIM_STATUS_ACCEPTED_WAITING_FOR_COMPENSATION_FROM_SHIPPER = 'acceptedWaitingForCompensationFromShipper';
export const CLAIM_STATUS_MORE_INFO_NEEDED = 'moreInfoNeeded';
export const CLAIM_STATUS_INFORMATION_ADDED = 'informationAdded';
export const CLAIM_STATUS_ACCEPTED_PENDING_CLIENT_COMPENSATION = 'acceptedPendingClientCompensation';

export const ClaimStatuses = [
    CLAIM_STATUS_RECEIVED,
    CLAIM_STATUS_IN_PROCESS,
    CLAIM_STATUS_ACCEPTED,
    CLAIM_STATUS_REJECTED,
    CLAIM_STATUS_STORNO,
    CLAIM_STATUS_ACCEPTED_WAITING_FOR_COMPENSATION_FROM_SHIPPER,
    CLAIM_STATUS_MORE_INFO_NEEDED,
    CLAIM_STATUS_INFORMATION_ADDED,
    CLAIM_STATUS_ACCEPTED_PENDING_CLIENT_COMPENSATION
];

export const CLAIM_PROPERTY_EDIT_KEYS = ['DESCRIPTION', 'FILES'] as const;

export const PACKER_NAME_UNAVAILABLE = 'N/A';

export const CLAIM_OPEN_STATUSES = [
    CLAIM_STATUS_RECEIVED,
    CLAIM_STATUS_IN_PROCESS,
    CLAIM_STATUS_ACCEPTED_WAITING_FOR_COMPENSATION_FROM_SHIPPER,
    CLAIM_STATUS_INFORMATION_ADDED,
    CLAIM_STATUS_MORE_INFO_NEEDED,
    CLAIM_STATUS_ACCEPTED_PENDING_CLIENT_COMPENSATION
] as const;

export const CLAIM_PACKER_SYNC_MAX_AGE_MONTHS = 1;

export const CLAIM_ERROR_DEPARTMENT_B2C = 'b2c';
export const CLAIM_ERROR_DEPARTMENT_B2B = 'b2b';
export const ClaimErrorDepartments = [CLAIM_ERROR_DEPARTMENT_B2C, CLAIM_ERROR_DEPARTMENT_B2B] as const;

export const CLAIM_ERROR_CATEGORY_PACKAGING_NON_COMPLIANCE = 'packagingNonCompliance';
export const CLAIM_ERROR_CATEGORY_PHYSICAL_HANDLING_ERROR = 'physicalHandlingError';
export const CLAIM_ERROR_CATEGORY_SCANNING_ERROR = 'scanningError';
export const CLAIM_ERROR_CATEGORY_INSUFFICIENT_PACKAGING = 'insufficientPackaging';
export const CLAIM_ERROR_CATEGORY_OTHERS = 'others';
export const ClaimErrorCategories = [
    CLAIM_ERROR_CATEGORY_PACKAGING_NON_COMPLIANCE,
    CLAIM_ERROR_CATEGORY_PHYSICAL_HANDLING_ERROR,
    CLAIM_ERROR_CATEGORY_SCANNING_ERROR,
    CLAIM_ERROR_CATEGORY_INSUFFICIENT_PACKAGING,
    CLAIM_ERROR_CATEGORY_OTHERS
] as const;

export const CLAIM_ERROR_SEVERITY_LOW = 1;
export const CLAIM_ERROR_SEVERITY_MEDIUM = 2;
export const CLAIM_ERROR_SEVERITY_HIGH = 3;
export const ClaimErrorSeverities = [
    CLAIM_ERROR_SEVERITY_LOW,
    CLAIM_ERROR_SEVERITY_MEDIUM,
    CLAIM_ERROR_SEVERITY_HIGH
] as const;

export const CLAIM_ERROR_LOG_EDIT_KEYS = [
    'ERROR_RESPONSIBLE',
    'ERROR_DEPARTMENT',
    'ERROR_CATEGORY',
    'ERROR_DESCRIPTION',
    'ERROR_SEVERITY',
    'VIDEO_LINK'
] as const;

export const ClaimCauses = [
    'lost',
    'damaged',
    'deliveryTimeExceeded',
    'others',
    'trackingLabelsSwapped',
    'duplicatedLabels',
    'missingItems',
    'exceedingItems',
    'swappedItems'
];

export const ClaimResolvers = ['skladon', 'carrier', 'skladonIT'];

export const ClaimAllowedOrderStatuses = ['onTheWay', 'atPickupPoint', 'delivered', 'returnedBack', 'returningBack', 'lost'];

export const ClaimStatusesTo: Record<string, string[]> = {
    received: ['inProcess', 'storno'],
    inProcess: ['rejected', 'accepted', 'partiallyAccepted', 'storno'],
    rejected: ['accepted', 'partiallyAccepted', 'storno'],
    notFound: ['accepted', 'partiallyAccepted', 'storno'],
    accepted: ['rejected', 'storno'],
    storno: ['accepted', 'partiallyAccepted'],
    acceptedWaitingForCompensationFromShipper: ['received', 'inProcess', 'rejected', 'notFound', 'accepted', 'storno'],
    moreInfoNeeded: ['informationAdded', 'received', 'storno'],
    informationAdded: ['inProcess', 'storno'],
    acceptedPendingClientCompensation: ['accepted']
};